module.exports = __webpack_public_path__ + "img/list-bullet.3cd53e9.svg";